var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.show?'open':'',attrs:{"id":"app"}},[_c('Header',{ref:"student",attrs:{"activeIdx":_vm.idx}}),_c('router-view',{ref:"tabIdx"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }